import React, { useRef, useState, useMemo } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import CustomTooltip from "./tooltip";
import { backgroundColors } from "../utils/backgroundColors";

ChartJS.register(ArcElement, Tooltip, Legend);

const IndustryChart = ({ data: apiData }) => {
  const chartRef = useRef();
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    data: null,
  });

  const data = useMemo(
    () => ({
      labels: apiData.map((item) => item.mcc),
      datasets: [
        // inner doughnut
        {
          data: apiData.map((item) => item.count),
          backgroundColor: backgroundColors.slice(0, apiData.length),
          radius: "70%",
          cutout: "0%",
          borderColor: "#fff",
          borderWidth: 2,
          borderRadius: 5,
        },
        // outer doughnut
        {
          data: apiData.map((item) => item.total_sales),
          offset: 10,
          backgroundColor: backgroundColors.slice(0, apiData.length),
          radius: "100%",
          cutout: "86%",
          borderColor: "#fff",
          borderWidth: 2,
          borderRadius: 5,
        },
      ],
    }),
    [apiData],
  );

  const options = useMemo(
    () => ({
      responsive: false,
      maintainAspectRatio: false,
      plugins: {
        tooltip: {
          enabled: false,
          external: (context) => {
            const tooltipModel = context.tooltip;
            if (
              !tooltipModel ||
              !tooltipModel.opacity ||
              !tooltipModel.dataPoints?.length
            ) {
              setTooltip((prev) => ({ ...prev, visible: false }));
              return;
            }

            const dp = tooltipModel.dataPoints[0];
            const index = dp.dataIndex;

            setTooltip({
              visible: true,
              x: tooltipModel.caretX,
              y: tooltipModel.caretY,
              data: {
                ...apiData[index],
                color: dp.element.options.backgroundColor,
              },
            });
          },
        },
        legend: { display: false },
      },
      layout: { padding: 0 },
    }),
    [apiData],
  );

  return (
    <div style={{ position: "relative" }}>
      <Doughnut
        ref={chartRef}
        data={data}
        options={options}
        height={230}
        width={230}
      />
      {tooltip.visible && (
        <CustomTooltip x={tooltip.x} y={tooltip.y} data={tooltip.data} />
      )}
    </div>
  );
};

export default IndustryChart;
